export enum ModificationMode {
  Add = 'add',
  Edit = 'edit',
}
